"use client";

import React from "react";

const Loader = () => {
  return (
    <div className="loader">
      <div className="box1" />
      <div className="box2" />
      <div className="box3" />
    </div>
  );
};

export default Loader;
